// eslint-disable-next-line jira/filename-case
import React from 'react';
import { NAVIGATION_CREATE_ISSUE_BUTTON_NUDGE_ID } from '@jira/platform__onboarding-core/src/constants.tsx';
import { OnboardingNudgeErrorBoundary } from '@jira/platform__onboarding-quickstart-core/src/common/ui/onboarding-nudge-error-boundary/index.tsx';
import type { QuickstartNudgeWrapperBaseProps } from '@jira/platform__onboarding-quickstart-core/src/common/ui/quickstart-nudge/types.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { useCanShowQuickstartNudge } from './useCanShowQuickstartNudge.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NavigationCreateIssueButtonLazy = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-software-onboarding-navigation-create-issue-nudge" */ './NavigationCreateIssueButtonWrapperNudge.tsx'
		).then((exportedModule) => exportedModule.NavigationCreateIssueButtonWrapperNudge),
	{
		ssr: false,
	},
);
export const NavigationCreateIssueButtonWrapperNudgeAsync = ({
	children,
}: QuickstartNudgeWrapperBaseProps): React.JSX.Element => {
	const shouldShowNudge = useCanShowQuickstartNudge();

	if (!shouldShowNudge) {
		return <>{children}</>;
	}

	return (
		<OnboardingNudgeErrorBoundary
			id={NAVIGATION_CREATE_ISSUE_BUTTON_NUDGE_ID}
			fallback={children}
			attributes={{
				nudgeId: NAVIGATION_CREATE_ISSUE_BUTTON_NUDGE_ID,
			}}
		>
			<Placeholder
				name="software-onboarding-navigation-create-issue-nudge"
				fallback={<>{children}</>}
			>
				<NavigationCreateIssueButtonLazy nudgeId={NAVIGATION_CREATE_ISSUE_BUTTON_NUDGE_ID}>
					{children}
				</NavigationCreateIssueButtonLazy>
			</Placeholder>
		</OnboardingNudgeErrorBoundary>
	);
};
